import config from "../utils/config";
import { js_utils } from "../utils/frfr-js-utils";
import { _makeIdent } from "./ter-ident-utils";
import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _podeli_virtel_na_sections } from "./ter-virtel-utils";

// BACKED UTILS

// NOVO 2021mart
// koristicemo posebno kreiranje genusa i genus_ident, a posebno upis instanci koje vec imaju genus_ident.

const conf = {
  poredi_input: true,
  poredi_der: true
}


export const backendUtilsGenusCountersUpdateAndGetId = (genus_counters) => {
  let new_count = false;
  // fdbCrudUtils.update = function (id, entity, tablename, db) {
  let new_genus_counters = genus_counters.map((item) => {
    if (item.counter_id === 'genus_counters') {
      new_count = item.counter_all + 1;
      return {
        ...item,
        counter_all: new_count
      };
    }
    return item;
  });
  return [new_genus_counters, new_count];
};


// NOVO
const OLD_backendUtilsFrontendOutboxToBackendP = (state) => {
  /*
  Ovde se podaci iz statea forme prepakuju za slanje na backend. 
  - Propertiji koji pripadaju genusu (klasi elementa) ostaju a ostali propertiji se premestaju u .extra property 
  */

  /*
  TODO: SMISLITI:
  - svi podoaci koji pripadaju instanci neka idu u properti koji ce se zvati 
  .instanceData, ._extra ili ._meta
  - podaci koji pripadaju instanci su id, tracker, roditeljElementid, superkey, i dlicno.
  - svi ostali podaci pripadaju genusu (tj. klasi od kojeg insatnce povlace)
  - vecina tih podatak koje pripadaju genusu se nalaze u formDefinition ali poneki kao sto je broj komada pripadaj uinstancama.

  ZATIM: kod svakog submita ove podatke upakovati u taj .extra na priemr.
  a na backendu moraju opet biti tako spakovani...
  */
};


export const _entityVirtelInstance = (genus_ident, virtel) => {
  // BACKEND
  const sema = virtel_schema_smart_get(virtel.virtelschemakey);
  const virtel_sect_instance = _podeli_virtel_na_sections(virtel, sema).sect_instance;
  let new_instance = {
    ...virtel_sect_instance,
    db_instance_flag_standalone: false,
    db_instance_flag_genus: true,
    db_join_with_genus: true,
    virtelschemakey: virtel.virtelschemakey,
    genus_ident,
    readme: 'ovo je virtel insatanca. sadrzi samo genus_ident (i meta podatke) i kasnije ce biti wrapovana sa superkey-om'
  };
  return new_instance;
};
export const _entityVirtelInstanceStandalone = (virtel) => {
  // BACKEND
  const sema = virtel_schema_smart_get(virtel.virtelschemakey);
  const virtel_sect = _podeli_virtel_na_sections(virtel, sema);
  const virtel_sect_instance = virtel_sect.sect_instance;
  const virtel_sect_genus = virtel_sect.sect_genus;
  let new_entity = {
    ...virtel_sect_instance,
    ...virtel_sect_genus,
    db_instance_flag_standalone: true,
    db_instance_flag_genus: false,
    db_join_with_genus: false,
    virtelschemakey: virtel.virtelschemakey,
    genus_ident: false,
    readme: 'ovo je standalone virtel insatanca. i kasnije ce biti wrapovana sa superkey-om'
  };
  return new_entity;
};
export const _entityVirtelUni = (virtel, genus_ident) => {
  // BACKEND
  // entitet koji moze da ide u tabelu u koju idu i standalone i instance genusa
  const sema = virtel_schema_smart_get(virtel.virtelschemakey);
  const _sect = _podeli_virtel_na_sections(virtel, sema);
  const virtel_sect_instance = _sect.sect_instance;
  const virtel_sect_genus = _sect.sect_genus;
  let new_uni_entity = {
    ...virtel_sect_instance,
    ...virtel_sect_genus,
    // db_instance_flag_standalone: false,
    // db_instance_flag_genus: false,
    // db_join_with_genus: false,
    db_join_with_genus: false,
    genus_ident: null, // ZA SADA iskljuceni genusi
    virtelschemakey: virtel.virtelschemakey,
    readme: 'ovo je virtel UNI entity. sadrzi db_join_with_genus i kasnije ce biti wrapovan sa superkey-om'
  };
  return new_uni_entity;
};


export const _get_virtel_for_each_instance = (instances_arr, genus_arr) => {
  console.log(instances_arr, genus_arr);
  // BACKEND sklapanja instanci za frontend
  let result_instances = [];
  instances_arr.forEach((instance) => {
    let frontend_instance = false;
    /*
    db_instance_flag_standalone: true,
    db_instance_flag_genus: false,
    */
    if (instance.db_instance_flag_genus === true) {
      genus_arr.forEach((g) => {
        if (g.genus_ident === instance.genus_ident) {
          // console.log('_get_virtel_for_each_instance');
          // console.log(g);
          // console.log(g.gfields);
          // console.log(instance);
          frontend_instance = {
            ...instance,
            ...g.gfields,
            virtelschemakey: g.virtelschemakey,
            genus_ident: g.genus_ident
          };
          // console.log(frontend_instance);
        }
      });
      result_instances.push(frontend_instance);
    }
    if (instance.db_instance_flag_standalone === true) {
      // STNADALNOE INSTANCES
      frontend_instance = {
        ...instance,
        virtelschemakey: instance.virtelschemakey
      };
      result_instances.push(frontend_instance);
    }
  });
  return result_instances;
};


const _compare_single_item_with_genus = (_item, _genus) => {
  console.log(' +++ evo sta se poredi 1');
  let ovaj_genus_se_podudara = false;
  let test = true;

  if (_genus.gfields && _genus.virtelschemakey && _item.virtelschemakey && _item.virtelschemakey === _genus.virtelschemakey) {
  } else {
    return false;
  }

  let item = {}; // privremeno
  // console.log(_item.virtelschemakey);
  console.log(_item);
  console.log(_item.virtelschemakey);
  const sema = virtel_schema_smart_get(_item.virtelschemakey);
  if (sema) {
    item = _podeli_virtel_na_sections(_item, sema);
  }

  let genus = {};
  // console.log(_genus.virtelschemakey);
  const gsema = virtel_schema_smart_get(_genus.virtelschemakey);
  if (gsema) {
    // genus = _podeli_virtel_na_sections(_genus.gfields, gsema);
    // ne poredimo nista sem sect_genus
    genus.sect_genus = _genus.gfields; // mora pri poredjenju da se uvaze sva upisana polja jer su sva uticala na definisanje genusa
  }

  // PRIPREMA OBJEKATA

  if (!js_utils.is_object(item.sect_genus)) {
    item.sect_genus = {}; // samostalni podaci
  }

  // ne poredimo nista osim sect_genus polja

  // POREDJENJE

  if (true) {
    // poredjenje sect_genus
    if (!js_utils.compare_shallow_objects(item.sect_genus, genus.sect_genus)) {
      test = false;
    }
  }

  // ne poredimo nista osim sect_genus polja

  // if (ovaj_genus_se_podudara === true) {
  if (test === true) {
    // ako ga je nasao onda imamo bar jedan podudaran genus i nasli smo to sto trazimo. imamo genus_ident njegov
    // postoji_takav_genus = true;
    ovaj_genus_se_podudara = true;
    // genus_ident = g.genus_ident;
    // genus_ident = _genus.genus_ident;
  }

  // if (_item.virtelschemakey === 'terkk$modul$profilosnovni') {
  // if (true) {
  // console.log('evo sta se poredi 2');
  // console.log(item);
  // console.log(genus);
  // console.log(ovaj_genus_se_podudara);
  // }
  return ovaj_genus_se_podudara;
};


export const _backendUtilsVirtelGenusUpdateSmart = (genus_arr, virtel, fresh_genus_counter) => {
  // ...MakePpGenusAndInstancess ???

  if (config.backend_ganus_enabled === false) {
    // ako je iskljucena upotreba genus funkcionalnosti
    return {
      genus_arr,
      genus_ident: null,
      is_updated: false
    };
  }
  //
  // SMART UPDATE GENUS ARR AND RETURN GENUS_IDENT FOR SINGLE VIRTEL
  const p = virtel; // kasnije preimenovati u v
  let genus_arr_changed = false;
  let new_genus_arr = [...genus_arr]; // inicijalno počinje od starih. nema brisanja, samo dodvanje
  console.log(genus_arr);
  // PRIVATE FUNC
  const _dirty_genusArrUpdateSmart = (p) => {
    // DIRTY
    let genus_ident = null;
    let postoji_takav_genus = false;
    // detect maxIdent
    if (new_genus_arr.length === 0) {
      postoji_takav_genus = false;
    } else {
      postoji_takav_genus = false;
      new_genus_arr.forEach((g) => {
        // COMPARE genus with p from draft
        let ovaj_genus_se_podudara = _compare_single_item_with_genus(p, g);
        // console.log(' _compare_single_item_with_genus(p, g) ', ovaj_genus_se_podudara);

        // jedan genus je obradjen
        if (ovaj_genus_se_podudara === true) {
          // ako ga je nasao onda imamo bar jedan podudaran genus i nasli smo to sto trazimo. imamo genus_ident njegov
          postoji_takav_genus = true;
          genus_ident = g.genus_ident;
        }
        // console.log(postoji_takav_genus, 'genus_ident', genus_ident);
      });
    }

    console.log('***Da li vec postoji takav: ', postoji_takav_genus, genus_ident);
    if (postoji_takav_genus === true) {
      // objekat identican objektu. to je taj.
      // genus_ident je vec upisan u promenjivu genus_ident. ne radimo nista ovde
      genus_arr_changed = false;
    } else {
      // ako ne postoji genus, kreiramo NOVI GENUS_IDENT I NOVI GENUS
      const virtelschemakey = p.virtelschemakey;
      genus_ident = _makeIdent(virtelschemakey, fresh_genus_counter);
      // genus sadrzi samo odredjene sect-ove koje odlucimo da cuvamo u genusu
      const sema = virtel_schema_smart_get(virtelschemakey);
      const sect = _podeli_virtel_na_sections(p, sema);
      console.log(p);
      console.log(sect);
      let newGenus = {
        genus_ident,
        ident_prefix: 'PLACEHOLDER',
        ident_number: 'PLACEHOLDER',
        virtelschemakey: p.virtelschemakey,
        gfields: {
          ...sect.sect_genus
        }
      };
      new_genus_arr.push(newGenus); // DIRTY UPDATE
      genus_arr_changed = true;
    }
    console.log(genus_ident);
    return genus_ident;
  }; // end of _dirtyGenusUpdateSmart

  const genus_ident = _dirty_genusArrUpdateSmart(p);

  console.log('pre return');
  return {
    genus_arr: new_genus_arr,
    genus_ident: genus_ident,
    is_updated: genus_arr_changed
  };
};

